// extracted by mini-css-extract-plugin
export default {"clt_31_75":"styles_clt_31_75__zjTV-","clt_31_74":"styles_clt_31_74__ThbFr"};